module.exports = __webpack_public_path__ + "img/gas4.73d81bc2.png";